<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconiconfont-kemu-copy"></i>
      已报名考官
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-around" v-if="mianfei">
        <div class="flex align-start">
          <h3 class="margin-right padding-top">考生报名-免费</h3>
          <div class="flex flex-direction">
            <img :src="imgUrl+mianfei" alt="" width="200px">
            <el-link :href="imgUrl+mianfei" target="_blank" type="primary" class="margin-top">
              <el-button type="primary" class="submit-btn">下载</el-button>
            </el-link>
          </div>

        </div>
        <div class="flex align-start">
          <h3 class="margin-right padding-top">考生报名-收费</h3>
          <div class="flex flex-direction">
            <img :src="imgUrl+shoufei" alt="" width="200px">
            <el-link :href="imgUrl+shoufei" target="_blank" type="primary" class="margin-top">
              <el-button type="primary" class="submit-btn">下载</el-button>
            </el-link>
          </div>

        </div>
      </div>
      <div class="margin-top">
        <h3 class="flex align-center justify-between margin-bottom-sm">已报名考官
          <p>
            <el-button type="primary" @click="invitationAll">一键邀请</el-button>
          </p>
        </h3>
        <el-table
            :data="examinerList"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            fit
            style="width: 100%"
        >
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.examer_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="考官类型">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.type_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="手机号">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.phone }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份证号">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.examer_idcard }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.state_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="考点">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.org_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="是否打分">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.dafen }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="350px">
            <template slot-scope="scope">
              <div class="table-operate">
                <el-button
                    v-if="scope.row.state ===1"
                    size="medium"
                    type="primary"
                    @click="distribuItem(scope.row.id,scope.$index)"
                >分配考场
                </el-button>
                <el-button
                    size="medium"
                    type="primary"
                    @click="showItem(scope.row.examer_id)"
                >查看考官信息
                </el-button>
                <el-button
                    v-if="scope.row.state ===1"
                    size="medium"
                    type="primary"
                    @click="setItem(scope.row.id,-2)"
                >停用
                </el-button>
                <el-button
                    v-if="scope.row.state ===-2"
                    size="medium"
                    type="primary"
                    @click="setItem(scope.row.id,1)"
                >启用
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
            v-if="examinerList.length > 0"
            class="page-all"
            background
            @current-change="setPage"
            :current-page.sync="page"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
      <div class="margin-top">
        <h3 class="flex align-center justify-between">参与考务</h3>
        <div class="padding flex align-center">
          <div class="class-list-box">
            <h3>考场列表({{ roomKwList.length }})</h3>
            <ul class="class-list">
              <li :class="{'active':item.org_id === roomId}" v-for="item in roomKwList" :key="item.class_id"
                  @click="roomId = item.org_id">{{ item.org_name }}({{ item.num }}人)
              </li>
            </ul>
          </div>
          <div class="student-list-box">
            <h3>考务列表({{ kwList.length }})</h3>
            <ul class="student-list">
              <li v-for="item in kwList" :key="item.stu_name">{{ item.name }} - {{ item.phone }} （{{item.sign === 1?'已签到':'未签到'}}）</li>

            </ul>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        :title="'分配考场'"
        :visible.sync="distribuDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
      <el-form :model="distribuForm" :rules="rules" ref="distribuForm" label-width="100px">
        <el-form-item label="考场" prop="room">
          <el-select v-model="distribuForm.room" placeholder="请选择考场" style="width: 100%;" @change="setRoom">
            <el-option
                v-for="item in roomList"
                :key="item.org_id"
                :label="item.org_name"
                :value="item.org_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="flex align-center justify-around" label-width="0">
          <el-button class="padding-lr-xl" @click="resetForm('distribuForm')">取消</el-button>
          <el-button class="padding-lr-xl" type="primary" @click="submitForm('distribuForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
        :title="'考官信息'"
        :visible.sync="examinerDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="1200px"
        center>
      <el-form :model="examinerForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="考官编号" prop="name">
              <el-input v-model="examinerForm.number" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考官类型" prop="type">
              <el-select v-model="examinerForm.type" placeholder="请选择考官类型" style="width: 100%;" disabled>
                <el-option label="专业考官" value="1"></el-option>
                <el-option label="HR考官" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考官姓名" prop="name">
              <el-input v-model="examinerForm.name" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idcard">
              <el-input v-model="examinerForm.idcard" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话" prop="phone">
              <el-input v-model="examinerForm.phone" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="examinerForm.email" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行" prop="bank">
              <el-input v-model="examinerForm.bank" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行卡号" prop="bank_card">
              <el-input v-model="examinerForm.bank_card" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在单位" prop="danwei">
              <el-input v-model="examinerForm.danwei" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮寄地址" prop="address">
              <el-input v-model="examinerForm.address" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="简介" prop="address">
              <el-input type="textarea" v-model="examinerForm.desc" rows="5" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="个人正面照" prop="photo">
              <img :src="imgUrl + examinerForm.photo" class="avatar"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="flex align-center justify-around" label-width="0">
          <el-button class="padding-lr-xl" type="primary" @click="examinerDialog = false">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>


    <el-dialog
        :title="'考官邀请'"
        :visible.sync="examinerChioseDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="1200px"
        center>

      <div>
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="checkedExaminer" @change="handleCheckedCitiesChange">
          <div class="flex align-center flex-wrap">
            <el-checkbox style="width: 12%;margin-bottom: 10px;" v-for="item in examiners" :label="item.id" :key="item.id">{{ item.type === 1 ? '专业' : 'HR' }} -
              {{ item.name }}
            </el-checkbox>
          </div>

        </el-checkbox-group>
      </div>
      <div class="flex align-center justify-around margin-top">
        <el-button class="padding-lr-xl" @click="examinerChioseDialog = false">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitChiose">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  allotRoom,
  stopExaminer,
  examinerInvite,
  examExaminerList,
  examinerInfo,
  checkRoomList,
  getErweima, examRoomList, examServerList, examinerInviteList
} from "@/api/projectOffice";
import {IMGURL} from "@/config";

export default {
  name: "examInvite",
  data() {
    return {
      page: 1,
      limit: 10,
      total: 0,
      mianfei: '',
      shoufei: '',

      examinerChioseDialog: false,
      examiners: [],
      checkAll: false,
      checkedExaminer: [],
      isIndeterminate: false,
      examinerList: [],
      distribuDialog: false,
      setId: '',
      roomList: [],
      distribuForm: {
        room: '',
        roomText: ''
      },
      rules: {
        room: [{required: true, message: '请选择考场', trigger: 'change'}]
      },
      examinerDialog: false,
      examinerForm: {
        type: '',
        name: '',
        idcard: '',
        phone: '',
        email: '',
        bank: '',
        bank_card: '',
        danwei: '',
        address: '',
        photo: ''
      },
      roomId: '',
      roomKwList: [],
      kwList: [],
    };
  },
  computed: {

    imgUrl() {
      return IMGURL
    },
    allChiose() {
      let _arr = []
      this.examiners.map(item => {
        _arr.push(item.id)
      })
      return _arr
    }
  },
  created() {
    this.$emit(
        "setIndex",
        '/projectOffice/examination',
        "当前位置：考试管理 > 邀请报名",
        true
    );
    this.getList()
    this.getImgs()
  },
  methods: {
    // 获取二维码
    async getImgs() {
      let _data = await getErweima(this.$route.query.id)
      this.mianfei = _data.data.url_stu
      this.shoufei = _data.data.url_stu_fee
    },
    //  获取邀请的考官
    async getList() {
      let _data = await examExaminerList(this.$route.query.id, this.page, this.limit)
      this.examinerList = _data.data.list
      this.total = _data.data.count
      let _list = await checkRoomList(this.$route.query.id, '', '', '');
      this.roomList = _list.data
      let _list2 = await examRoomList(this.$route.query.id, 1, 1000)
      this.roomKwList = _list2.data.data
      if (this.roomKwList.length > 0) this.roomId = this.roomKwList[0].org_id
    },
    //  获取考场列表
    async examServerList() {
      let _list = await examServerList(this.$route.query.id, this.roomId, 1, 1000)
      this.kwList = _list.data.data
    },

    setPage() {
      this.getList();
    },
    //  一键邀请
    async invitationAll() {
      let _list = await examinerInviteList(this.$route.query.id);
      this.examiners = _list.data
      if(this.examiners.length === 0) return this.$message.error('当前没有可邀请的考官')
      this.examinerChioseDialog = true
    },
    //  选择要邀请的考官
    handleCheckAllChange(val) {
      this.checkedExaminer = val ? this.allChiose : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.examiners.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.examiners.length;
    },
    //  邀请考官
    async submitChiose() {
      if (this.checkedExaminer.length === 0) return this.$message.error('请选择要邀请的考官')
      let _state = await examinerInvite(this.$route.query.id, this.checkedExaminer.join(','))
      this.$message.success(_state.msg)
      this.examinerChioseDialog = false
      this.getList()
    },

    //  显示考官信息
    async showItem(id) {
      let _data = await examinerInfo(id)
      this.examinerForm = {
        type: Number(_data.data.type),
        name: _data.data.name,
        idcard: _data.data.idcard,
        phone: _data.data.phone,
        email: _data.data.email,
        bank: _data.data.bank,
        bank_card: _data.data.bank_card,
        danwei: _data.data.danwei,
        address: _data.data.address,
        photo: _data.data.photo,
      }
      this.examinerDialog = true
    },
    //  设置考官停用
    setItem(id, num) {
      this.$confirm(num === -2 ? "确定要停用该考官吗？" : "确定要启用该考官吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id, num);
      });
    },
    async sureDelete(id, num) {
      let _state = await stopExaminer(id, num);
      this.getList();
      this.$message.success(_state.msg);
    },
    //  分配考场
    distribuItem(id, index) {
      this.setId = id
      if (this.examinerList[index].org_id) {
        this.distribuForm.room = this.examinerList[index].org_id
        this.distribuForm.roomText = this.examinerList[index].org_name
      }
      this.distribuDialog = true
    },
    //  id过滤名称
    setRoom(val) {
      this.roomList.map(item => {
        if (val === item.org_id) this.distribuForm.roomText = item.org_name
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.distribuDialog = false
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await allotRoom(
          this.setId,
          this.distribuForm.room,
          this.distribuForm.roomText,
      );
      this.$message.success(_state.msg);
      this.$refs[formName].resetFields();
      this.distribuDialog = false
      this.getList();
    }
  },
  watch: {
    distribuDialog() {
      if (!this.distribuDialog) this.setId = ''
    },
    examinerChioseDialog() {
      if (!this.examinerChioseDialog) {
        this.examiners = []
        this.checkAll = false
        this.checkedExaminer = []
        this.isIndeterminate = false
      }
    },
    roomId() {
      this.examServerList()
    }
  }
}
</script>

<style scoped lang="scss">
.class-list-box {
  width: 48%;
  min-height: 400px;
  padding: 10px 20px;
  margin-right: 20px;
  border: 1px solid #e5e5e5;

  h3 {
    font-size: 18px;
    line-height: 20px;
    font-weight: bold;
    margin: 10px 0 20px;
    padding-left: 10px;
    border-left: 3px solid #009688;
  }

  .class-list {
    li {
      line-height: 36px;
      cursor: pointer;
      background-color: #f1f1f1;
      border-radius: 4px;
      margin-bottom: 5px;
      padding: 0 10px;

      &.active {
        background: #009688;
        color: #fff;
      }
    }
  }
}

.student-list-box {
  width: 48%;
  min-height: 400px;
  padding: 10px 20px;
  margin-right: 20px;
  border: 1px solid #e5e5e5;

  h3 {
    font-size: 18px;
    line-height: 20px;
    font-weight: bold;
    margin: 10px 0 20px;
    padding-left: 10px;
    border-left: 3px solid #009688;
  }

  .student-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 10px;

    li {
      width: 100%;
      line-height: 36px;
      cursor: pointer;
      background-color: #f1f1f1;
      border-radius: 4px;
      margin-bottom: 5px;
      padding: 0 10px;

      &.active {
        background: #009688;
        color: #fff;
      }
    }
  }
}
</style>